import { render, staticRenderFns } from "./ClientZoneAnalysis.vue?vue&type=template&id=06afc83e&scoped=true&"
import script from "./ClientZoneAnalysis.vue?vue&type=script&lang=js&"
export * from "./ClientZoneAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./ClientZoneAnalysis.vue?vue&type=style&index=0&id=06afc83e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06afc83e",
  null
  
)

export default component.exports